module.exports = __webpack_public_path__ + "images/wheeler-and-dealer-1b31607cdc8a3af4b9c65f8bf96f12b2.png";